import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/checkout" element={<CheckoutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}